import React from 'react'

import api from '../../utils/api'
import { AppContext } from '../App'
import { withNotifier } from '../Notifications'
import Modal from '../Modal'

import Form from './Form'

const USER_ENDPOINT = '/user/rest/user'
const decorate = withNotifier

class AddUser extends React.Component {
  static contextType = AppContext

  addUser = async (values) => {
    try {
      const response = await this.context.withAuth(USER_ENDPOINT, {
        method: 'POST',
        payload: { ...values, unitId: this.props.unitId },
      })

      response && this.props.handleModalStates('AddUser')
      this.props.notify('Użytkownik został dodany', 'success')
    } catch (e) {
      e.status === 409 &&
        this.props.notify(
          'Podany login jest zajęty przez innego użytkownika',
          'error'
        )
    }
  }

  render() {
    return (
      <Modal isOpen={this.props.modalReady} title="Dodaj osobę">
        <Form onClose={this.props.onClose} onSubmit={this.addUser} newModel />
      </Modal>
    )
  }
}

export default decorate(AddUser)
